import React, { useEffect, useState } from "react";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import { getUser } from "../../Utils/auth";
import { toast, ToastContainer, Bounce } from "react-toastify";
import DocumentRequestTable from "../Common/DocumentRequestTable";
import api from "../../setupMiddleware";

const GenerateDocument = () => {
  const loading = useApiLoader();
  const [requestOpen, setRequestOpen] = useState(false);
  const [requestRejectOpen, setRequestRejectOpen] = useState(false);
  const [docReq, setDocReq] = useState([]);

  const getAllRequests = async () => {
    api
      .get("/api/request-documents")
      .then((res) => {
        if (res && res.status === 200) {
          setDocReq(res.data?.data);
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
      });
  };

  const approveDocument = async (request_id) => {
    try {
      await api
        .post(`/api/request-documents/${request_id}/approve`)
        .then((res) => {
          if (res && res.status === 200) {
            if (res.data.status) {
              toast.success(res.data?.message, {
                position: "top-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
              });
            } else {
              toast.error(res.data?.message, {
                position: "top-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
              });
            }
            setRequestOpen(false);
            getAllRequests();
          }
        });
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      setRequestOpen(false);
    }
  };

  const rejectDocument = async (request_id) => {
    try {
      await api
        .post(`/api/request-documents/${request_id}/cancel`)
        .then((res) => {
          if (res && res.status === 200) {
            if (res.data.status) {
              toast.success(res.data?.message, {
                position: "top-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
              });
            } else {
              toast.error(res.data?.message, {
                position: "top-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
              });
            }
            setRequestRejectOpen(false);
            getAllRequests();
          }
        });
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      setRequestRejectOpen(false);
    }
  };

  useEffect(() => {
    getAllRequests();
  }, []);

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Requested Documents
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Approve or reject document requests
          </span>
        </p>
      </div>

      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                Document Requests
              </p>
            </div>
            <DocumentRequestTable
              data={docReq}
              handleApprove={approveDocument}
              handleReject={rejectDocument}
              requestOpen={requestOpen}
              setRequestOpen={setRequestOpen}
              requestRejectOpen={requestRejectOpen}
              setRequestRejectOpen={setRequestRejectOpen}
            />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default GenerateDocument;
